export default __webpack_public_path__ + "static/media/box.24f92773.svg";